export const MessageInfra = {
  AsInformacoesNaoPuderamSerSalvas: 'As informações não puderam ser salvas!',
  ConsultaAtualizadaGravadaSemSucesso: 'Consulta(s) NÃO foi(ram) Atualizada(s) e/ou gravada(s)!',
  NaoFoiPossivelExcluirORegistro: 'Não foi possível excluir o registro!',
  RegistroSalvoComSucesso: 'Registro salvo com sucesso!',
  ConsultaAtualizadaGravadaComSucesso: 'Consulta(s) Atualizada(s) e/ou gravada(s) com sucesso!',
  RegistroAlteradoComSucesso: 'Registro alterado com sucesso!',
  ConfirmarNovoRegistro: 'Deseja incluir um novo registro?',
  RegistroNaoEncontrado: 'Registro não encontrado',
  RegistroExcluidoComSucesso: 'Registro excluído com sucesso!',
  VerifiqueOsCampos: 'Verifique os campos!',
  NenhumRegistroEncontrado: 'Nenhum registro encontrado!',
  AcessoNaoAutenticado: '401 - Acesso não autenticado!',
  SemPermissaoDeAcesso: '403 - Sem permissão de acesso!',
  SemPermissaoDeAcessoSemStatus: 'Sem permissão de acesso!',
  PermissaoDefinidaComSucesso: 'Permissão definida com sucesso!',
  ServicoNaoEncontrado: '404 - Serviço não encontrado!',
  Conflito: '409 - Conflito',
  ErroAoEnviarToken: 'Falha ao Gerar/Enviar Token!',
  EnviadoComSucesssoToken: 'E-mail com Token enviado com Sucesso!',
  TokenNaoValido: 'Token não valido!',
  TokenValidoComSucesso: 'Token ou Senha da Hora validado com sucesso!',
  SessaoExpirada: 'Sessão expirada!',
  SessaoExisteAtiva: 'Existe uma Sessão ativa, caso queria realizar o login, favor deslogar da Sessao!',
  SessaoNaoExisteAtiva: 'Não existe sessão ativa, favor realizar o login no sistema!',
  SessaoEncerrada: 'Sessão encerrada!',
  Aguarde: 'Aguarde!',
  UsuarioBloquedo: 'Usuário Bloqueado!',
  UsuarioNaoAtivo: 'Usuário não está Ativo!',
  UsuarioSemAcesso: 'Usuário sem acesso, sendo redirecionado para a página inicial!',
  UsuarioPerfilDeAcessoAlterado: 'Usuário seu perfil de acesso foi alterado, favor realizar o login novamente!',

  RespostaIncorreta: "Resposta incorreta",
  TentativaExcedidaRespostaSecreta: "Excedida a quantidade(3) máxima de tentativa da Resposta Secreta.",
  NovaSenhaRedefinida: "Nova Senha Redefinida",
  ErroNovaSenhaRedefinida: "Error ao Redefinir Nova Senha",
  SenhaInvalida: "Senha inválida",
  ConfirmacaoSenhaDeveSerIgualSenha: "Confirmação de senha deve ser igual a senha",
  ErroRegraSenha: "Senha deve conter no mínimo: 1 (uma) letra maiúscula, 1 (uma) letra minúscula, 6 (seis) números e 1 (uma) caractere especial",
  LoginInvalido: "Login inválido",

  ParametroEmFormatoInesperado: '405 - Parametro em formato inesperado!',
  ErroInternoNoServidor: '500 - Erro interno no servidor!',
  LimiteDeTempoExcedido: '504 - Limite de tempo excedido!',
  FalhaAoConectarComOServidor: 'Falha ao conectar com o servidor!',
  AtencaoCpfInvalido: 'Atenção CPF inválido!',
  VerifiqueOCampoConfirmeOEmail: 'Verifique o campo Confirme o E-mail',
  VerifiqueOCampoConfirmeASenha: 'Verifique o campo Confirme a Senha',
  ConfirmaExclusaoImagem: 'Confirma a exclusão da imagem?',
  ConfirmaExclusaoRegistro: 'Confirma a exclusão do registro?',
  TamanhoArquivoNaoPermitido: 'Tamanho de Arquivo não Permitido!',
  TipoArquivoNaoPermitido: 'Tipo de Arquivo não Permitido!',
  VeiculoAgendamentoProximo: 'Veículo possui uma viagem agendada próxima!',
  VeiculoViagemEmAndamento: 'Veículo possui uma viagem em andamento!',
  VeiculoViagemEmAndamentoNaoRetornou: 'Veículo encontra-se em uma viagem em andamento sem previsão de retorno!',
  VeiculoManutencaoProxima: 'Veículo possui uma manutenção agendada próxima!',
  DesejaProsseguirSolicitacao: 'Deseja prosseguir com a solicitação?',
  CasoProssuigaRetornarAntes: 'Se prosseguir com a solicitação, o veículo deve retornar antes de: ',
  CasoProssigaRealizarAntesOuDepoisViagem: 'Se prosseguir com a solicitação, a manutenção deve ser realizada depois do retorno da viagem ou antes de: ',
  VeiculoAgendamentoAprovadoProximo: 'Veículo já possui uma viagem aprovada!',
  VeiculoSelecioneDataDiferente: 'Selecione uma data que não ocorra entre: ',
  ConfirmaAprovacaoDaViagem: 'Confirma a aprovação da viagem?',
  ConfirmaReprovacaoDaViagem: 'Confirma a reprovação da viagem?',
  ViagemAprovadaComSucesso: 'Viagem aprovada com sucesso!',
  ViagemReprovadaComSucesso: 'Viagem reprovada com sucesso!',
  AnexoSelecionarExclusao: 'Selecione um anexo para apagar!',
  CepInvalido: 'O CEP informado é inválido!',
  DataRetornoDeveOcorrerDepoisDataSaida: 'A Data e Hora de Retorno devem ocorrer depois da Data e Hora e Saída!',
  RetornoJaCadastradoParaViagem: 'Retorno já cadastrado para a viagem ',
  DesejaContinuar: 'Deseja continuar?',
  CamposRepetidos: 'Campos Repetidos!',
  DesejaAtualizarRetornoViagem: 'Deseja atualizar o retorno desta viagem?',
  ExtensaoArquivoInvalida: 'Um ou mais arquivos possui extensão inválida! As extensões de anexo permitidas são: .doc, .docx, .xls, .xlsx, .pdf, .jpeg, .png.',
  ConfiguracaoDefinida: 'Configuração definida com sucesso!',
  NaoPossivelEditarBomba: 'Não é possível editar pois não existe uma Bomba vinculada ao Tanque informado!',
  NaoPossivelExcluirBomba: 'Não é possível excluir pois não existe uma Bomba vinculada ao Tanque informado!',
  RodizioExistenteParaDataHoraInformada: 'Há um rodízio de veículos existente para a Data e Hora de Saída informadas!',
  ExportacaoRealizadaComSucesso: 'Exportação realizada com sucesso!',
  ExportacaoNaoRealizada: 'Não foi possível realizar a exportação!',
  ExportacaoDeLogsNaoRealizada: 'Não foi possível realizar a exportação dos logs!',
  SemRegistro: 'Sem registro!',
  DesejaEfetuarFechamentoDeExercicio: 'Deseja confirmar o fechamento do exercício para o ano informado?',
  ConfirmarFechamentoDeExercicio: 'Após o fechamento não será possível efetuar lançamentos para o ano.',
  FechamentoDeExercicioRealizado: 'Fechamento realizado com sucesso! Novo exercício aberto!',
  FuncionalidadeEmDesenvolvimento: 'Não é possível completar a ação! Funcionalidade em desenvolvimento.',
  LinkExpirado: 'Seu link para troca de senha expirou!',
  EmailEnviadoRecuperarSenha: 'Foi enviado em seu e-mail um link para recuperar a senha.',
  SenhaAlteradaComSucesso: 'Senha alterada com sucesso!',
  TabelaCriadaComSucesso: 'Tabela Criada com sucesso!',
  NaoFoiPossivelCriarTabela: 'Não foi possível Criar a Tabela!',
  ConfirmaCriacaoDaTabela: 'Confirma a criação da Tabela, Caso exista a tabela todos os dados seram excluídos ?',

  ConfirmaExecucaoDaCarga: 'Confirma a execução da Carga?',
  CargaEmExecucao: 'Carga em Execução, favor acompanhar o status!',
  NaoFoiPossivelExecutarCarga: 'Não foi possível colocar a Carga em Execução!',
  CpfInvalido: "Cpf inválido",
  ErrorConsultaUsuarioPorCpf: "Erro ao consultar o Usuário por CPF.",
  DeAcordoComTermo:"É necessário ter ciência sobre o documento de Política de Privacidade e estar de acordo com o Termo de Responsabilidade.",
  CepValido: 'O Cep é valido!',
  CepNaoValido: 'O Cep não é valido!',
  CnpjInvalido: "Cnpj inválido",
  CpfNaoExisteNoSistemaBI: "Cpf não existe no Sistema B.I!",
  CpfJaExisteNoSistemaBI: "Cpf já existe no Sistema B.I!",
  Ajuda:
    "<div class='ajuda text-left p-0 p-l-20'>" +
    " <h2> Identificação </h2>" +
    "    <p>Essa é a tela inicial para acesso à área restrita do Sistema de Contabilidade CECAM.</p>" +
    "    <p>Neste momento você tem as seguintes opções:</p>" +
    "    <ol>" +
    "        <li>Informar seu usuário e sua senha de acesso, e clicar no botão \"Entrar\" para acessar a área restrita do sistema de Contabilidade CECAM;</li>" +
    "        <li>Clicar em Certificado Digital, caso queira acessar a área restrita do sistema de Contabilidade CECAM, através dessa funcionalidade;</li>" +
    "        <li>Clicar no botão \"Trocar Senha\", caso queira trocar sua senha.</li>" +
    "        <li>Clicar no botão \"Efetuar Cadastro\", caso queira realizar seu autocadastramento, para acesso à área restrita do sistema, o qual necessita de liberação do superior hierárquico.</li>" +
    "        <li>Clicar no link \"Esqueci minha senha\", caso queira receber uma nova senha para acesso à área restrita do sistema.</li>" +
    "    </ol>" +
    "    <h2>Campos de Entrada</h2>" +
    "    <p><strong>CPF: </strong>Informe seu código de acesso ao sistema de Contabilidade CECAM. Esse código é um CPF válido (máximo de onze caracteres). Campo obrigatório.</p>" +
    "    <p><strong>Senha: </strong></p>" +
    "    <h2>Botões</h2>" +
    "    <p><strong>Entrar - </strong>Clique no botão Entrar após fornecer seus dados para ter acesso à área restrita do sistema de Contabilidade CECAM. Na próxima tela você poderá selecionar a funcionalidade do sistema desejada, entre as diversas opções em que você estiver habilitado.</p>" +
    "    <p><strong>Trocar Senha - </strong>Clique nesse "+
    " <a _ngcontent-one-c387='' class='link' ng-reflect-router-link='/authentication/change-passwor' href='#/authentication/change-password'>link</a>"+
    " para trocar sua senha de acesso à área restrita do sistema de Contabilidade Cecam.</p>" +
    "    <p><strong>Efetuar Cadastro - </strong>Clique no botão Efetuar Cadastro para realizar seu autocadastramento, para acesso à área restrita do sistema, o qual necessita de liberação do superior hierárquico.</p>" +
    "    <h2>Links</h2>" +
    "    <p><strong>Esqueci minha Senha - </strong>Clique nesse"+
    " <a _ngcontent-bls-c387='' class='link' ng-reflect-router-link='/authentication/forgot' href='#/authentication/forgot'>link</a>"+
    "     para receber uma nova senha para acesso à área restrita do sistema.</p>" +
    "    <p><strong>Saiba como obter o certificado digital - </strong>Clique nesse link para acessar informações de como obter o certificado digital. <strong>(Em Breve)</strong></p>" +
    "    <p><strong>Acessível em Libras - </strong>Clique nesse imagem <img class='access-button' style='width: 20px;' data-src='assets/component-ac.png' alt='Conteúdo acessível em libras usando o VLibras Widget com opções dos Avatares Ícaro ou Hozana.' src='https://vlibras.gov.br/app/assets/component-ac.png'> para acessar informações em libras.</p>" +
    "</div>"
};
